import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { ALL_COACH_CALENDAR_QUERY_KEY } from "../../coach-management/hooks/useGetCoachCalendar";

export const useDeleteCoachAvailability = (coachId: string, onSuccess: (deletedId: string) => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['deleteCoachAvailability'],
        mutationFn: (availabilityId: string) => apiClient.fetchApi<{}, {}>({ method: 'DELETE', endpoint: `coachs/availabilities/${availabilityId}` }),
        onSuccess: (data, coachAvailabilityId) => {
            queryClient.invalidateQueries(ALL_COACH_CALENDAR_QUERY_KEY(coachId));
            onSuccess(coachAvailabilityId);
        }
    });
};
